import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c1f88b52"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-custom-main" }
const _hoisted_2 = { class: "app-toolbar pb-10" }
const _hoisted_3 = { class: "app-container d-flex flex-stack" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page-title d-flex flex-column justify-content-center flex-wrap" }, null, -1))
const _hoisted_5 = { class: "d-flex align-items-center gap-2 gap-lg-3" }
const _hoisted_6 = { class: "date-select-box rounded overflow-hidden" }
const _hoisted_7 = { class: "source-select-box rounded overflow-hidden" }
const _hoisted_8 = { class: "app-content flex-column-fluid" }
const _hoisted_9 = { class: "app-container" }
const _hoisted_10 = { class: "d-flex flex-column gap-10" }
const _hoisted_11 = { class: "card" }
const _hoisted_12 = { class: "card-body" }
const _hoisted_13 = { class: "d-flex flex-wrap flex-sm-nowrap" }
const _hoisted_14 = { class: "flex-grow-1" }
const _hoisted_15 = { class: "d-flex flex-wrap flex-stack" }
const _hoisted_16 = { class: "d-flex flex-column flex-grow-1" }
const _hoisted_17 = {
  key: 0,
  class: "border border-gray-300 border-dashed rounded p-5"
}
const _hoisted_18 = { class: "d-flex align-items-center mb-4" }
const _hoisted_19 = { class: "w-100 fs-5 fw-bold text-center text-info" }
const _hoisted_20 = { class: "fw-bold fs-2hx text-center" }
const _hoisted_21 = {
  key: 1,
  class: "border border-gray-300 border-dashed rounded p-5"
}
const _hoisted_22 = { class: "d-flex align-items-center mb-4" }
const _hoisted_23 = { class: "w-100 fs-5 fw-bold text-center text-primary" }
const _hoisted_24 = { class: "fw-bold fs-2hx text-center" }
const _hoisted_25 = {
  key: 2,
  class: "border border-gray-300 border-dashed rounded p-5"
}
const _hoisted_26 = { class: "d-flex align-items-center mb-4" }
const _hoisted_27 = { class: "w-100 fs-5 fw-bold text-center text-primary" }
const _hoisted_28 = { class: "fw-bold fs-2hx d-flex align-items-center justify-content-center" }
const _hoisted_29 = {
  key: 3,
  class: "border border-gray-300 border-dashed rounded p-5"
}
const _hoisted_30 = { class: "d-flex align-items-center mb-4" }
const _hoisted_31 = { class: "w-100 fs-5 fw-bold text-center text-success" }
const _hoisted_32 = { class: "fw-bold fs-2hx d-flex align-items-center justify-content-center" }
const _hoisted_33 = {
  key: 4,
  class: "border border-gray-300 border-dashed rounded p-5"
}
const _hoisted_34 = { class: "d-flex align-items-center mb-4" }
const _hoisted_35 = { class: "fw-bold fs-2hx d-flex align-items-center justify-content-center" }
const _hoisted_36 = {
  key: 5,
  class: "border border-gray-300 border-dashed rounded p-5"
}
const _hoisted_37 = { class: "d-flex align-items-center mb-4" }
const _hoisted_38 = { class: "w-100 fs-5 fw-bold text-center text-primary" }
const _hoisted_39 = { class: "fw-bold fs-2hx d-flex align-items-center justify-content-center" }
const _hoisted_40 = {
  key: 6,
  class: "border border-gray-300 border-dashed rounded p-5"
}
const _hoisted_41 = { class: "d-flex align-items-center mb-4" }
const _hoisted_42 = { class: "w-100 fs-5 fw-bold text-center text-success" }
const _hoisted_43 = { class: "fw-bold fs-2hx d-flex align-items-center justify-content-center" }
const _hoisted_44 = {
  key: 7,
  class: "border border-gray-300 border-dashed rounded p-5"
}
const _hoisted_45 = { class: "d-flex align-items-center mb-4" }
const _hoisted_46 = { class: "w-100 fs-5 fw-bold text-center text-danger" }
const _hoisted_47 = { class: "fw-bold fs-2hx d-flex align-items-center justify-content-center" }
const _hoisted_48 = {
  key: 8,
  class: "border border-gray-300 border-dashed rounded p-5"
}
const _hoisted_49 = { class: "d-flex align-items-center mb-4" }
const _hoisted_50 = { class: "w-100 fs-5 fw-bold text-center text-primary" }
const _hoisted_51 = { class: "fw-bold fs-2hx d-flex align-items-center justify-content-center" }
const _hoisted_52 = { class: "card card-flush" }
const _hoisted_53 = { class: "card-header align-items-center py-5 gap-2 gap-md-5" }
const _hoisted_54 = { class: "card-title" }
const _hoisted_55 = { class: "d-flex align-items-center text-dark fw-bolder my-1 fs-3" }
const _hoisted_56 = {
  class: "card-toolbar flex-row-fluid justify-content-end gap-5",
  "data-kt-customer-table-toolbar": "base"
}
const _hoisted_57 = ["disabled"]
const _hoisted_58 = { class: "svg-icon svg-icon-3" }
const _hoisted_59 = ["disabled"]
const _hoisted_60 = {
  key: 0,
  class: "spinner-border spinner-border-sm align-middle me-2"
}
const _hoisted_61 = {
  key: 1,
  class: "svg-icon svg-icon-3"
}
const _hoisted_62 = { class: "card-body pt-0" }
const _hoisted_63 = { class: "text-primary text-nowrap" }
const _hoisted_64 = {
  key: 0,
  class: "text-gray-400"
}
const _hoisted_65 = {
  key: 1,
  class: "text-gray-400"
}
const _hoisted_66 = {
  key: 2,
  class: "text-gray-400"
}
const _hoisted_67 = { class: "mw-260px text-nowrap" }
const _hoisted_68 = { class: "text-line-clamp-1" }
const _hoisted_69 = {
  key: 0,
  class: "text-line-clamp-1 text-gray-400"
}
const _hoisted_70 = {
  key: 1,
  class: "text-line-clamp-1 text-gray-400"
}
const _hoisted_71 = {
  key: 2,
  class: "text-gray-400"
}
const _hoisted_72 = { class: "text-nowrap" }
const _hoisted_73 = { class: "text-gray-400" }
const _hoisted_74 = {
  key: 0,
  class: "text-nowrap"
}
const _hoisted_75 = { key: 1 }
const _hoisted_76 = {
  key: 0,
  class: "text-nowrap"
}
const _hoisted_77 = { key: 1 }
const _hoisted_78 = { class: "text-nowrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_year_range_picker = _resolveComponent("year-range-picker")!
  const _component_CommonAgentAccountOption = _resolveComponent("CommonAgentAccountOption")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_custom_currency = _resolveComponent("custom-currency")!
  const _component_MBDatatablePlus = _resolveComponent("MBDatatablePlus")!
  const _directive_loading = _resolveDirective("loading")!
  const _directive_auth = _resolveDirective("auth")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_el_select, {
              class: "custom-select",
              modelValue: _ctx.options.dateType,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.options.dateType) = $event)),
              onChange: _ctx.defaultDate,
              disabled: _ctx.tableLoading
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.dateTypeOptions, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.value,
                    label: item.label,
                    value: item.value
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "onChange", "disabled"])
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["business-date-select-box rounded", {
              day: _ctx.options.dateType === 'day',
            }])
          }, [
            (_ctx.options.dateType === 'day')
              ? (_openBlock(), _createBlock(_component_el_date_picker, {
                  key: 0,
                  class: "custom-select w-100",
                  modelValue: _ctx.options.business_date,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.options.business_date) = $event)),
                  type: "daterange",
                  "start-placeholder": _ctx.t('common.dateStart'),
                  "end-placeholder": _ctx.t('common.dateEnd'),
                  format: _ctx.getDateType.format,
                  "value-format": _ctx.getDateType.valueFormat,
                  onChange: _ctx.handleFilter,
                  clearable: false,
                  disabled: _ctx.tableLoading,
                  shortcuts: _ctx.dayShortcuts,
                  "disabled-date": _ctx.disabledDate,
                  "range-separator": _ctx.$t('common.dateTo')
                }, null, 8, ["modelValue", "start-placeholder", "end-placeholder", "format", "value-format", "onChange", "disabled", "shortcuts", "disabled-date", "range-separator"]))
              : (_ctx.options.dateType === 'month')
                ? (_openBlock(), _createBlock(_component_el_date_picker, {
                    key: 1,
                    class: "custom-select w-100",
                    modelValue: _ctx.options.business_date,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.options.business_date) = $event)),
                    type: "monthrange",
                    "start-placeholder": _ctx.t('common.dateStart'),
                    "end-placeholder": _ctx.t('common.dateEnd'),
                    format: _ctx.getDateType.format,
                    "value-format": _ctx.getDateType.valueFormat,
                    onChange: _ctx.handleFilter,
                    clearable: false,
                    disabled: _ctx.tableLoading,
                    shortcuts: _ctx.monthShortcuts,
                    "disabled-date": _ctx.disabledDate,
                    "range-separator": _ctx.$t('common.dateTo')
                  }, null, 8, ["modelValue", "start-placeholder", "end-placeholder", "format", "value-format", "onChange", "disabled", "shortcuts", "disabled-date", "range-separator"]))
                : _createCommentVNode("", true),
            _withDirectives(_createVNode(_component_year_range_picker, {
              ref: "statisticPicker",
              class: "w-100",
              disabled: _ctx.tableLoading,
              shortcuts: _ctx.yearShortcuts,
              onUpdateTimeRange: _ctx.updateTimeRange,
              "disabled-date": _ctx.disabledYear,
              sp: _ctx.$t('common.dateTo')
            }, null, 8, ["disabled", "shortcuts", "onUpdateTimeRange", "disabled-date", "sp"]), [
              [_vShow, _ctx.options.dateType === 'year']
            ])
          ], 2),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_el_select, {
              class: "custom-select",
              modelValue: _ctx.options.source,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.options.source) = $event)),
              teleported: false,
              clearable: 
                _ctx.options.source !== 'all' && _ctx.options.source !== 'activated'
              ,
              filterable: "",
              "remote-show-suffix": "",
              remote: "",
              "remote-method": _ctx.searchAgentAccountsItems,
              loading: _ctx.options.sourceLoading,
              disabled: _ctx.tableLoading,
              onChange: _ctx.handleSourceSelect,
              placement: "bottom-start",
              "fit-input-width": true,
              onVisibleChange: _ctx.handleSourceBlur
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.sourceOptions, (item, key) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: key,
                    label: item.label,
                    value: item.value
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CommonAgentAccountOption, { option: item }, null, 8, ["option"])
                    ]),
                    _: 2
                  }, 1032, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "clearable", "remote-method", "loading", "disabled", "onChange", "onVisibleChange"])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["grid sm:grid-cols-1 gap-5 lh-1", `grid-cols-${_ctx.getTopGridColumnCount}`])
                      }, [
                        (_ctx.getTypeParams.quantity)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                              _createElementVNode("div", _hoisted_18, [
                                _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.getTypeParams.quantity), 1)
                              ]),
                              _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$currency.currency(
                                _ctx.options.summary.agent_count,
                                0,
                                ",",
                                ".",
                                ""
                              )), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.getTypeParams.quantityItems)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                              _createElementVNode("div", _hoisted_22, [
                                _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.getTypeParams.quantityItems), 1)
                              ]),
                              _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.$currency.currency(
                                _ctx.options.summary.total_transaction_product_count,
                                0,
                                ",",
                                ".",
                                ""
                              )), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.getTypeParams.net)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                              _createVNode(_component_el_popover, {
                                placement: "top",
                                width: "auto",
                                trigger: "hover",
                                "popper-class": "custom-popover",
                                offset: -20,
                                disabled: 
                              Number(_ctx.options.summary.transaction_net_amount) ===
                              0
                            
                              }, {
                                reference: _withCtx(() => [
                                  _createElementVNode("div", null, [
                                    _createElementVNode("div", _hoisted_26, [
                                      _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.getTypeParams.net), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.$currency.currency(
                                      _ctx.totalTransactionNetAmountC(
                                        _ctx.amountToParseInt(
                                          _ctx.options.summary.transaction_net_amount
                                        )
                                      ).value.amount,
                                      _ctx.totalTransactionNetAmountC(
                                        _ctx.options.summary.transaction_net_amount
                                      ).value.isMillion ||
                                        (Number(
                                          _ctx.options.summary.transaction_net_amount
                                        ) < 1 &&
                                          Number(
                                            _ctx.options.summary
                                              .transaction_net_amount
                                          ) > 0)
                                        ? 2
                                        : 0,
                                      ",",
                                      ".",
                                      ""
                                    ) +
                                    _ctx.totalTransactionNetAmountC(
                                      _ctx.options.summary.transaction_net_amount
                                    ).value.unit +
                                    " €"), 1)
                                  ])
                                ]),
                                default: _withCtx(() => [
                                  _createElementVNode("div", null, _toDisplayString(_ctx.$currency.currency(
                                  _ctx.options.summary.transaction_net_amount,
                                  2,
                                  ",",
                                  ".",
                                  ""
                                ) + " €"), 1)
                                ]),
                                _: 1
                              }, 8, ["disabled"])
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.getTypeParams.total)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                              _createVNode(_component_el_popover, {
                                placement: "top",
                                width: "auto",
                                trigger: "hover",
                                "popper-class": "custom-popover",
                                offset: -20,
                                disabled: 
                              Number(
                                _ctx.options.summary.total_transaction_net_amount
                              ) === 0
                            
                              }, {
                                reference: _withCtx(() => [
                                  _createElementVNode("div", null, [
                                    _createElementVNode("div", _hoisted_30, [
                                      _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.getTypeParams.total), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.$currency.currency(
                                      _ctx.totalTransactionNetAmountC(
                                        _ctx.amountToParseInt(
                                          _ctx.options.summary
                                            .total_transaction_net_amount
                                        )
                                      ).value.amount,
                                      _ctx.totalTransactionNetAmountC(
                                        _ctx.options.summary
                                          .total_transaction_net_amount
                                      ).value.isMillion ||
                                        (Number(
                                          _ctx.options.summary
                                            .total_transaction_net_amount
                                        ) < 1 &&
                                          Number(
                                            _ctx.options.summary
                                              .total_transaction_net_amount
                                          ) > 0)
                                        ? 2
                                        : 0,
                                      ",",
                                      ".",
                                      ""
                                    ) +
                                    _ctx.totalTransactionNetAmountC(
                                      _ctx.options.summary
                                        .total_transaction_net_amount
                                    ).value.unit +
                                    " €"), 1)
                                  ])
                                ]),
                                default: _withCtx(() => [
                                  _createElementVNode("div", null, _toDisplayString(_ctx.$currency.currency(
                                  _ctx.options.summary.total_transaction_net_amount,
                                  2,
                                  ",",
                                  ".",
                                  ""
                                ) + " €"), 1)
                                ]),
                                _: 1
                              }, 8, ["disabled"])
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.getTypeParams.grossTotal)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                              _createVNode(_component_el_popover, {
                                placement: "top",
                                width: "auto",
                                trigger: "hover",
                                "popper-class": "custom-popover",
                                offset: -20,
                                disabled: 
                              Number(
                                _ctx.options.summary.total_transaction_gross_amount
                              ) === 0
                            
                              }, {
                                reference: _withCtx(() => [
                                  _createElementVNode("div", null, [
                                    _createElementVNode("div", _hoisted_34, [
                                      _createElementVNode("div", {
                                        class: _normalizeClass(["w-100 fs-5 fw-bold text-center", {
                                      'text-primary': _ctx.type !== 'rebate',
                                      'text-danger': _ctx.type === 'rebate',
                                    }])
                                      }, _toDisplayString(_ctx.getTypeParams.grossTotal), 3)
                                    ]),
                                    _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.$currency.currency(
                                      _ctx.totalTransactionNetAmountC(
                                        _ctx.amountToParseInt(
                                          _ctx.options.summary
                                            .total_transaction_gross_amount
                                        )
                                      ).value.amount,
                                      _ctx.totalTransactionNetAmountC(
                                        _ctx.options.summary
                                          .total_transaction_gross_amount
                                      ).value.isMillion ||
                                        (Number(
                                          _ctx.options.summary
                                            .total_transaction_gross_amount
                                        ) < 1 &&
                                          Number(
                                            _ctx.options.summary
                                              .total_transaction_gross_amount
                                          ) > 0)
                                        ? 2
                                        : 0,
                                      ",",
                                      ".",
                                      ""
                                    ) +
                                    _ctx.totalTransactionNetAmountC(
                                      _ctx.options.summary
                                        .total_transaction_net_amount
                                    ).value.unit +
                                    " €"), 1)
                                  ])
                                ]),
                                default: _withCtx(() => [
                                  _createElementVNode("div", null, _toDisplayString(_ctx.$currency.currency(
                                  _ctx.options.summary
                                    .total_transaction_gross_amount,
                                  2,
                                  ",",
                                  ".",
                                  ""
                                ) + " €"), 1)
                                ]),
                                _: 1
                              }, 8, ["disabled"])
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.getTypeParams.taxTotal)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                              _createVNode(_component_el_popover, {
                                placement: "top",
                                width: "auto",
                                trigger: "hover",
                                "popper-class": "custom-popover",
                                offset: -20,
                                disabled: 
                              Number(
                                _ctx.options.summary.total_transaction_tax_amount
                              ) === 0
                            
                              }, {
                                reference: _withCtx(() => [
                                  _createElementVNode("div", null, [
                                    _createElementVNode("div", _hoisted_37, [
                                      _createElementVNode("div", _hoisted_38, _toDisplayString(_ctx.getTypeParams.taxTotal), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_39, _toDisplayString(_ctx.$currency.currency(
                                      _ctx.totalTransactionNetAmountC(
                                        _ctx.amountToParseInt(
                                          _ctx.options.summary
                                            .total_transaction_tax_amount
                                        )
                                      ).value.amount,
                                      _ctx.totalTransactionNetAmountC(
                                        _ctx.options.summary
                                          .total_transaction_tax_amount
                                      ).value.isMillion ||
                                        (Number(
                                          _ctx.options.summary
                                            .total_transaction_tax_amount
                                        ) < 1 &&
                                          Number(
                                            _ctx.options.summary
                                              .total_transaction_tax_amount
                                          ) > 0)
                                        ? 2
                                        : 0,
                                      ",",
                                      ".",
                                      ""
                                    ) +
                                    _ctx.totalTransactionNetAmountC(
                                      _ctx.options.summary
                                        .total_transaction_tax_amount
                                    ).value.unit +
                                    " €"), 1)
                                  ])
                                ]),
                                default: _withCtx(() => [
                                  _createElementVNode("div", null, _toDisplayString(_ctx.$currency.currency(
                                  _ctx.options.summary.total_transaction_tax_amount,
                                  2,
                                  ",",
                                  ".",
                                  ""
                                ) + " €"), 1)
                                ]),
                                _: 1
                              }, 8, ["disabled"])
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.getTypeParams.refundableTotal)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                              _createVNode(_component_el_popover, {
                                placement: "top",
                                width: "auto",
                                trigger: "hover",
                                "popper-class": "custom-popover",
                                offset: -20,
                                disabled: 
                              Number(
                                _ctx.options.summary.total_refundable_amount
                              ) === 0
                            
                              }, {
                                reference: _withCtx(() => [
                                  _createElementVNode("div", null, [
                                    _createElementVNode("div", _hoisted_41, [
                                      _createElementVNode("div", _hoisted_42, _toDisplayString(_ctx.getTypeParams.refundableTotal), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.$currency.currency(
                                      _ctx.totalTransactionNetAmountC(
                                        _ctx.amountToParseInt(
                                          _ctx.options.summary
                                            .total_refundable_amount
                                        )
                                      ).value.amount,
                                      _ctx.totalTransactionNetAmountC(
                                        _ctx.options.summary.total_refundable_amount
                                      ).value.isMillion ||
                                        (Number(
                                          _ctx.options.summary
                                            .total_refundable_amount
                                        ) < 1 &&
                                          Number(
                                            _ctx.options.summary
                                              .total_refundable_amount
                                          ) > 0)
                                        ? 2
                                        : 0,
                                      ",",
                                      ".",
                                      ""
                                    ) +
                                    _ctx.totalTransactionNetAmountC(
                                      _ctx.options.summary.total_refundable_amount
                                    ).value.unit +
                                    " €"), 1)
                                  ])
                                ]),
                                default: _withCtx(() => [
                                  _createElementVNode("div", null, _toDisplayString(_ctx.$currency.currency(
                                  _ctx.options.summary.total_refundable_amount,
                                  2,
                                  ",",
                                  ".",
                                  ""
                                ) + " €"), 1)
                                ]),
                                _: 1
                              }, 8, ["disabled"])
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.getTypeParams.refundedTotal)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                              _createVNode(_component_el_popover, {
                                placement: "top",
                                width: "auto",
                                trigger: "hover",
                                "popper-class": "custom-popover",
                                offset: -20,
                                disabled: 
                              Number(_ctx.options.summary.total_refunded_amount) ===
                              0
                            
                              }, {
                                reference: _withCtx(() => [
                                  _createElementVNode("div", null, [
                                    _createElementVNode("div", _hoisted_45, [
                                      _createElementVNode("div", _hoisted_46, _toDisplayString(_ctx.getTypeParams.refundedTotal), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_47, _toDisplayString(_ctx.$currency.currency(
                                      _ctx.totalTransactionNetAmountC(
                                        _ctx.amountToParseInt(
                                          _ctx.options.summary.total_refunded_amount
                                        )
                                      ).value.amount,
                                      _ctx.totalTransactionNetAmountC(
                                        _ctx.options.summary.total_refunded_amount
                                      ).value.isMillion ||
                                        (Number(
                                          _ctx.options.summary.total_refunded_amount
                                        ) < 1 &&
                                          Number(
                                            _ctx.options.summary
                                              .total_refunded_amount
                                          ) > 0)
                                        ? 2
                                        : 0,
                                      ",",
                                      ".",
                                      ""
                                    ) +
                                    _ctx.totalTransactionNetAmountC(
                                      _ctx.options.summary.total_refunded_amount
                                    ).value.unit +
                                    " €"), 1)
                                  ])
                                ]),
                                default: _withCtx(() => [
                                  _createElementVNode("div", null, _toDisplayString(_ctx.$currency.currency(
                                  _ctx.options.summary.total_refunded_amount,
                                  2,
                                  ",",
                                  ".",
                                  ""
                                ) + " €"), 1)
                                ]),
                                _: 1
                              }, 8, ["disabled"])
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.getTypeParams.paidTotal)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                              _createVNode(_component_el_popover, {
                                placement: "top",
                                width: "auto",
                                trigger: "hover",
                                "popper-class": "custom-popover",
                                offset: -20,
                                disabled: 
                              Number(_ctx.options.summary.total_paid_amount) === 0
                            
                              }, {
                                reference: _withCtx(() => [
                                  _createElementVNode("div", null, [
                                    _createElementVNode("div", _hoisted_49, [
                                      _createElementVNode("div", _hoisted_50, _toDisplayString(_ctx.getTypeParams.paidTotal), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_51, _toDisplayString(_ctx.$currency.currency(
                                      _ctx.totalTransactionNetAmountC(
                                        _ctx.amountToParseInt(
                                          _ctx.options.summary.total_paid_amount
                                        )
                                      ).value.amount,
                                      _ctx.totalTransactionNetAmountC(
                                        _ctx.options.summary.total_paid_amount
                                      ).value.isMillion ||
                                        (Number(
                                          _ctx.options.summary.total_paid_amount
                                        ) < 1 &&
                                          Number(
                                            _ctx.options.summary.total_paid_amount
                                          ) > 0)
                                        ? 2
                                        : 0,
                                      ",",
                                      ".",
                                      ""
                                    ) +
                                    _ctx.totalTransactionNetAmountC(
                                      _ctx.options.summary.total_paid_amount
                                    ).value.unit +
                                    " €"), 1)
                                  ])
                                ]),
                                default: _withCtx(() => [
                                  _createElementVNode("div", null, _toDisplayString(_ctx.$currency.currency(
                                  _ctx.options.summary.total_paid_amount,
                                  2,
                                  ",",
                                  ".",
                                  ""
                                ) + " €"), 1)
                                ]),
                                _: 1
                              }, 8, ["disabled"])
                            ]))
                          : _createCommentVNode("", true)
                      ], 2)
                    ])
                  ])
                ])
              ])
            ])), [
              [_directive_loading, _ctx.detailLoading]
            ])
          ]),
          _createElementVNode("div", _hoisted_52, [
            _createElementVNode("div", _hoisted_53, [
              _createElementVNode("div", _hoisted_54, [
                _createElementVNode("h1", _hoisted_55, _toDisplayString(_ctx.getTypeParams.title), 1)
              ]),
              _createElementVNode("div", _hoisted_56, [
                _createElementVNode("button", {
                  type: "button",
                  class: _normalizeClass(["btn max-sm-btn", {
                    'btn-light': _ctx.isDefaultView,
                    'btn-light-primary': !_ctx.isDefaultView,
                  }]),
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.reset && _ctx.reset(...args))),
                  disabled: _ctx.tableLoading || _ctx.isDefaultView
                }, [
                  _createElementVNode("span", _hoisted_58, [
                    _createVNode(_component_inline_svg_icon, { src: "media/svg/custom/reset-view.svg" })
                  ]),
                  _createElementVNode("span", null, _toDisplayString(_ctx.t("entityRelationships.resetView")), 1)
                ], 10, _hoisted_57),
                _withDirectives((_openBlock(), _createElementBlock("button", {
                  type: "button",
                  class: "btn btn-light-primary",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.filesExport('all'))),
                  disabled: _ctx.disabledExportAll || _ctx.tableLoading
                }, [
                  (_ctx.disabledExportAll)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_60))
                    : (_openBlock(), _createElementBlock("span", _hoisted_61, [
                        _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr078.svg" })
                      ])),
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t("common.export")), 1)
                ], 8, _hoisted_59)), [
                  [_directive_auth, { auth: ['export'] }]
                ])
              ])
            ]),
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_62, [
              _createVNode(_component_MBDatatablePlus, {
                "table-data": _ctx.tableData,
                "table-header": _ctx.tableHeader,
                order: _ctx.sortOrder,
                "diy-order": true,
                "sort-label": _ctx.sortLabel,
                "current-page": _ctx.currentPage,
                total: _ctx.total,
                "rows-per-page": _ctx.pageSize,
                showExpandBtn: false,
                "total-array": _ctx.options.totalArray,
                onSelectChange: _ctx.onRowsSelectChange,
                onCurrentChange: _ctx.onCurrentPageChange,
                onItemsPerPageChange: _ctx.onRowsPerPageChange,
                onDiySortClick: _ctx.onColumnSort
              }, {
                "cell-settlement_entity_id": _withCtx(({ row: item }) => [
                  _createElementVNode("div", _hoisted_63, _toDisplayString(item.account?.settlement_entity_id
                        ? item.account?.settlement_entity_id
                        : "--"), 1)
                ]),
                "cell-account_name": _withCtx(({ row: item }) => [
                  _createVNode(_component_el_popover, {
                    placement: "top-start",
                    width: "auto",
                    trigger: "hover",
                    "popper-class": "custom-popover"
                  }, {
                    reference: _withCtx(() => [
                      _createElementVNode("div", _hoisted_67, [
                        _createElementVNode("div", _hoisted_68, _toDisplayString(item.account?.account_name
                              ? item.account?.account_name
                              : item.account?.settlement_entity_name
                              ? item.account?.settlement_entity_name
                              : "--"), 1),
                        (
                            _ctx.type === 'clientele' && item.account?.vat_number
                          )
                          ? (_openBlock(), _createElementBlock("div", _hoisted_69, _toDisplayString(item.account?.vat_number), 1))
                          : (
                            (item.account?.country || item.account?.city) &&
                            _ctx.type !== 'clientele'
                          )
                            ? (_openBlock(), _createElementBlock("div", _hoisted_70, _toDisplayString(item.account?.city +
                            (item.account?.city && item.account?.country
                              ? ", "
                              : "") +
                            item.account?.country), 1))
                            : (_openBlock(), _createElementBlock("div", _hoisted_71, "--"))
                      ])
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("div", null, [
                        _createElementVNode("div", null, _toDisplayString(item.account?.account_name
                            ? item.account?.account_name
                            : item.account?.settlement_entity_name
                            ? item.account?.settlement_entity_name
                            : "--"), 1),
                        (_ctx.type === 'clientele' && item.account?.vat_number)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_64, _toDisplayString(item.account?.vat_number), 1))
                          : (
                          (item.account?.country || item.account?.city) &&
                          _ctx.type !== 'clientele'
                        )
                            ? (_openBlock(), _createElementBlock("div", _hoisted_65, _toDisplayString(item.account?.city +
                          (item.account?.city && item.account?.country
                            ? ", "
                            : "") +
                          item.account?.country), 1))
                            : (_openBlock(), _createElementBlock("div", _hoisted_66, "--"))
                      ])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                "cell-payment_account": _withCtx(({ row: item }) => [
                  _createElementVNode("div", _hoisted_72, [
                    _createElementVNode("div", null, _toDisplayString(item.account?.payment_method), 1),
                    _createElementVNode("div", _hoisted_73, _toDisplayString(item.account?.payment_account
                          ? item.account?.payment_account
                          : "--"), 1)
                  ])
                ]),
                "cell-business_date": _withCtx(({ row: item }) => [
                  (item.business_date)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_74, _toDisplayString(item.business_date
                        ? _ctx.formatUtcDate(
                            String(item.business_date),
                            _ctx.getDateType.format
                          )
                        : "--"), 1))
                    : (_openBlock(), _createElementBlock("div", _hoisted_75, "--"))
                ]),
                "cell-purpose_payment": _withCtx(({ row: item }) => [
                  (item.account?.paid_goal)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_76, _toDisplayString(item.account?.paid_goal), 1))
                    : (_openBlock(), _createElementBlock("div", _hoisted_77, "--"))
                ]),
                "cell-transaction_product_count": _withCtx(({ row: item }) => [
                  _createElementVNode("div", _hoisted_78, _toDisplayString(_ctx.$currency.currency(
                        item.transaction_product_count,
                        0,
                        ",",
                        ".",
                        ""
                      )), 1)
                ]),
                "cell-transaction_gross_amount": _withCtx(({ row: item }) => [
                  _createElementVNode("div", null, [
                    _createVNode(_component_el_popover, {
                      placement: "top-end",
                      width: "auto",
                      trigger: "hover",
                      "popper-class": "custom-popover",
                      disabled: Number(item.transaction_gross_amount) === 0
                    }, {
                      reference: _withCtx(() => [
                        _createVNode(_component_custom_currency, {
                          currency: 'EUR',
                          amount: 
                            _ctx.amountToParseInt(item.transaction_gross_amount)
                          ,
                          precision: 
                            Number(item.transaction_gross_amount) < 1 &&
                            Number(item.transaction_gross_amount) > 0
                              ? 2
                              : 0
                          
                        }, null, 8, ["amount", "precision"])
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_custom_currency, {
                          currency: 'EUR',
                          amount: item.transaction_gross_amount
                        }, null, 8, ["amount"])
                      ]),
                      _: 2
                    }, 1032, ["disabled"])
                  ])
                ]),
                "cell-transaction_tax_amount": _withCtx(({ row: item }) => [
                  _createElementVNode("div", null, [
                    _createVNode(_component_el_popover, {
                      placement: "top-end",
                      width: "auto",
                      trigger: "hover",
                      "popper-class": "custom-popover",
                      disabled: Number(item.transaction_tax_amount) === 0
                    }, {
                      reference: _withCtx(() => [
                        _createVNode(_component_custom_currency, {
                          currency: 'EUR',
                          amount: 
                            _ctx.amountToParseInt(item.transaction_tax_amount)
                          ,
                          precision: 
                            Number(item.transaction_tax_amount) < 1 &&
                            Number(item.transaction_tax_amount) > 0
                              ? 2
                              : 0
                          
                        }, null, 8, ["amount", "precision"])
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_custom_currency, {
                          currency: 'EUR',
                          amount: item.transaction_tax_amount
                        }, null, 8, ["amount"])
                      ]),
                      _: 2
                    }, 1032, ["disabled"])
                  ])
                ]),
                "cell-refundable_amount": _withCtx(({ row: item }) => [
                  _createElementVNode("div", null, [
                    _createVNode(_component_el_popover, {
                      placement: "top-end",
                      width: "auto",
                      trigger: "hover",
                      "popper-class": "custom-popover",
                      disabled: Number(item.refundable_amount) === 0
                    }, {
                      reference: _withCtx(() => [
                        _createVNode(_component_custom_currency, {
                          currency: 'EUR',
                          amount: _ctx.amountToParseInt(item.refundable_amount),
                          precision: 
                            Number(item.refundable_amount) < 1 &&
                            Number(item.refundable_amount) > 0
                              ? 2
                              : 0
                          
                        }, null, 8, ["amount", "precision"])
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_custom_currency, {
                          currency: 'EUR',
                          amount: item.refundable_amount
                        }, null, 8, ["amount"])
                      ]),
                      _: 2
                    }, 1032, ["disabled"])
                  ])
                ]),
                "cell-refunded_amount": _withCtx(({ row: item }) => [
                  _createElementVNode("div", null, [
                    _createVNode(_component_el_popover, {
                      placement: "top-end",
                      width: "auto",
                      trigger: "hover",
                      "popper-class": "custom-popover",
                      disabled: Number(item.refunded_amount) === 0
                    }, {
                      reference: _withCtx(() => [
                        _createVNode(_component_custom_currency, {
                          currency: 'EUR',
                          amount: _ctx.amountToParseInt(item.refunded_amount),
                          precision: 
                            Number(item.refunded_amount) < 1 &&
                            Number(item.refunded_amount) > 0
                              ? 2
                              : 0
                          
                        }, null, 8, ["amount", "precision"])
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_custom_currency, {
                          currency: 'EUR',
                          amount: item.refunded_amount
                        }, null, 8, ["amount"])
                      ]),
                      _: 2
                    }, 1032, ["disabled"])
                  ])
                ]),
                "cell-paid_amount": _withCtx(({ row: item }) => [
                  _createElementVNode("div", null, [
                    _createVNode(_component_el_popover, {
                      placement: "top-end",
                      width: "auto",
                      trigger: "hover",
                      "popper-class": "custom-popover",
                      disabled: Number(item.paid_amount) === 0
                    }, {
                      reference: _withCtx(() => [
                        _createVNode(_component_custom_currency, {
                          currency: 'EUR',
                          amount: _ctx.amountToParseInt(item.paid_amount),
                          precision: 
                            Number(item.paid_amount) < 1 &&
                            Number(item.paid_amount) > 0
                              ? 2
                              : 0
                          
                        }, null, 8, ["amount", "precision"])
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_custom_currency, {
                          currency: 'EUR',
                          amount: item.paid_amount
                        }, null, 8, ["amount"])
                      ]),
                      _: 2
                    }, 1032, ["disabled"])
                  ])
                ]),
                "cell-transaction_net_total": _withCtx(({ row: item }) => [
                  _createElementVNode("div", null, [
                    _createVNode(_component_el_popover, {
                      placement: "top-end",
                      width: "auto",
                      trigger: "hover",
                      "popper-class": "custom-popover",
                      disabled: Number(item.transaction_net_total) === 0
                    }, {
                      reference: _withCtx(() => [
                        _createVNode(_component_custom_currency, {
                          currency: 'EUR',
                          amount: _ctx.amountToParseInt(item.transaction_net_total),
                          precision: 
                            Number(item.transaction_net_total) < 1 &&
                            Number(item.transaction_net_total) > 0
                              ? 2
                              : 0
                          
                        }, null, 8, ["amount", "precision"])
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_custom_currency, {
                          currency: 'EUR',
                          amount: item.transaction_net_total
                        }, null, 8, ["amount"])
                      ]),
                      _: 2
                    }, 1032, ["disabled"])
                  ])
                ]),
                "cell-transaction_net_amount": _withCtx(({ row: item }) => [
                  _createElementVNode("div", null, [
                    _createVNode(_component_el_popover, {
                      placement: "top-end",
                      width: "auto",
                      trigger: "hover",
                      "popper-class": "custom-popover",
                      disabled: Number(item.transaction_net_amount) === 0
                    }, {
                      reference: _withCtx(() => [
                        _createVNode(_component_custom_currency, {
                          currency: 'EUR',
                          amount: 
                            _ctx.amountToParseInt(item.transaction_net_amount)
                          ,
                          precision: 
                            Number(item.transaction_net_amount) < 1 &&
                            Number(item.transaction_net_amount) > 0
                              ? 2
                              : 0
                          
                        }, null, 8, ["amount", "precision"])
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_custom_currency, {
                          currency: 'EUR',
                          amount: item.transaction_net_amount
                        }, null, 8, ["amount"])
                      ]),
                      _: 2
                    }, 1032, ["disabled"])
                  ])
                ]),
                _: 1
              }, 8, ["table-data", "table-header", "order", "sort-label", "current-page", "total", "rows-per-page", "total-array", "onSelectChange", "onCurrentChange", "onItemsPerPageChange", "onDiySortClick"])
            ])), [
              [_directive_loading, _ctx.tableLoading]
            ])
          ])
        ])
      ])
    ])
  ]))
}